/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：706
 */

module.exports = {
  wrapper: "RightSideMenu_wrapper__pn2lJ",
  itemMenu: "RightSideMenu_itemMenu__2wrm-",
  normal: "RightSideMenu_normal__jAKu2",
  active: "RightSideMenu_active__R-hSf",
  consoleError: "RightSideMenu_consoleError__APIzo",
  content: "RightSideMenu_content__2itCW",
  showContent: "RightSideMenu_showContent__3cTB7",
  hideComponent: "RightSideMenu_hideComponent__5dZ0c",
  showComponent: "RightSideMenu_showComponent__2CMi3",
  searchInput: "RightSideMenu_searchInput__xW86M"
}
